import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IMAGES } from "../lib/funnelData";

export const Preloader = () => {
  const [show, setShow] = useState(() => {
    try {
      return !sessionStorage.getItem("cr_preloader_seen");
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (!show) return undefined;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      setShow(false);
      try {
        sessionStorage.setItem("cr_preloader_seen", "1");
      } catch {}
    }, 2100);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, [show]);

  useEffect(() => {
    if (!show) document.body.style.overflow = "";
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] bg-emeraldx-deeper flex flex-col items-center justify-center overflow-hidden"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="absolute inset-0 pattern-contour-light" />
          <div className="overlay-grain" />
          <motion.img
            src={IMAGES.logoWhite}
            alt="Cann Realty LLC"
            data-testid="preloader-logo"
            className="relative h-14 sm:h-20 w-auto"
            initial={{ opacity: 0, scale: 0.94, filter: "blur(6px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          />
          <motion.div
            className="relative mt-7 h-px bg-oak"
            initial={{ width: 0 }}
            animate={{ width: 140 }}
            transition={{ duration: 1.5, ease: "easeInOut", delay: 0.4 }}
          />
          <motion.span
            className="relative mt-5 text-[10px] font-mono uppercase tracking-[0.4em] text-canvas/60"
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            Land · Farms · Homes
          </motion.span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
